<template>
  <b-modal id="add_pay_group" ref="add_pay_group" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1><i class="fas fa-business-time"></i> <span>Add default pay group</span></h1>
        <p id="mh-info">Add a payment group for {{ $store.state.companies.pay_group_modal.company_name }}</p>
      </div>
      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <ValidationObserver ref="addPayGroupForm" slim>
      <form role="form" @submit.prevent="submit_form">
        <div class="row">
          <!-- Payment day -->
          <ValidationProvider rules="required" v-slot="{errors, classes}" name="Payment Day" tag="div" class="col-6 form-group">
            <label class="form-label" for="pay_group_day">Payment Day</label>
            <multiselect v-model="pay_group.pay_group_day" id="pay_group_day" name="pay_group_day" placeholder=""
                         :options="ms_opts.pay_group_days" :class="classes"></multiselect>
            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
          </ValidationProvider>
          <!-- Payment time -->
          <ValidationProvider rules="required" v-slot="{errors, classes}" name="Payment Time" tag="div" class="col-6 form-group">
            <label class="form-label" for="pay_group_time">Payment Time</label>
            <multiselect v-model="pay_group.pay_group_time" id="pay_group_time" name="pay_group_time" placeholder=""
                         :options="ms_opts.pay_group_hours" :class="classes"></multiselect>
            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
          </ValidationProvider>
          <!-- Text day -->
          <ValidationProvider rules="required" v-slot="{errors, classes}" name="Text Day" tag="div" class="col-6 form-group">
            <label class="form-label" for="text_day">Text Day</label>
            <multiselect v-model="pay_group.text_day" id="text_day" name="text_day" placeholder=""
                         :options="ms_opts.text_days" :class="classes"></multiselect>
            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
          </ValidationProvider>
          <!-- Text Time -->
          <ValidationProvider rules="required" v-slot="{errors, classes}" name="Text Time" tag="div" class="col-6 form-group">
            <label class="form-label" for="text_time">Text Time</label>
            <multiselect v-model="pay_group.text_time" id="text_time" name="text_time" placeholder=""
                         :options="ms_opts.text_hours" :class="classes"></multiselect>
            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
          </ValidationProvider>
          <div class="col-6 offset-6">
            <button class="btn orcaBtn w-100 mt-3">Save</button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import { getChangedFields } from 'utils/utils'; // Import the function
// js arrays
import days_of_week from "resources/js/assets/crm_options/days_of_week";
import hours_of_day from "resources/js/assets/crm_options/shift_times";

export default {
  name: "add_pay_group",
  components: {
    Multiselect
  },
  data() {
    return {
      ms_opts: {
        pay_group_days: days_of_week,
        pay_group_hours: hours_of_day,
        text_days: days_of_week,
        text_hours: hours_of_day
      },
      pay_group: {
        company_id: this.$store.state.companies.pay_group_modal.company_id,
        pay_group_day: null,
        pay_group_time: null,
        text_day: null,
        text_time: null,
        // Set log values (current crm user)
        log_by_type: 'App\\Models\\Users\\User',
        log_by_id: this.$store.state.auth.me.id
      },
      original_pay_group: {} // Add this to hold the original state
    }
  },
  created() {
    this.original_pay_group = Object.assign({}, this.pay_group); // Initialize the original state
  },
  methods: {
    hideModal() {
      this.$refs.add_pay_group.hide();
      this.$store.commit('HIDE_ADD_PAY_GROUP_MODAL');
    },
    submit_form() {
      this.$refs.addPayGroupForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.addPayGroupForm);
        }
        else {

          
          let changed_fields = [
            ...getChangedFields(this.original_pay_group, this.pay_group),
          ];

          axios.post(this.crmApiPath + 'company/pay_groups', this.pay_group).then(() => {
            if (changed_fields.length > 0) {
              axios.post(this.crmApiPath + 'company/send_changed_email', {
                title: 'PAY GROUP CHANGES',
                company_id: this.pay_group.company_id,
                changes: changed_fields,
              }).then(() => {
                this.$bus.$emit('logs::reload', {action: true});
                this.$bus.$emit('company::reload', {action: true});
                this.hideModal();
              });
            } else {
              this.$bus.$emit('logs::reload', {action: true});
              this.$bus.$emit('company::reload', {action: true});
              this.hideModal();
            }
          });
          
        }
      })
    },
  }
}
</script>
